/*
 * @Desc: 
 * @Author: lc
 * @Date: 2024-12-30 15:04:44
 * @LastEditors: lc
 * @LastEditTime: 2024-12-30 15:06:00
 */
/**
  * 充值卡 接口的统一出口
  */
import axios from '.././http'; // 导入http中创建的axios实例
import qs from 'qs'; // 根据需求是否导入qs模块，把请求字段直接映射过来


// 接口请求地址
const api = '/c-api/jinfeixibi/';

const tiku = {
    // 列表
    config (params) {
        return axios.get(api + 'tiku/config', { params: params })
    },
    //添加
    editconfig (params) {
        return axios.post(api + 'tiku/editconfig', qs.stringify(params))
    },
    //获取编辑信息
    list (params) {
        return axios.get(api + 'tiku/list', { params: params })
    },
    create (params) {
        return axios.post(api + 'tiku/create', qs.stringify(params))
    },
    edit (params) {
        return axios.post(api + 'tiku/edit', qs.stringify(params))
    },
    status (params) {
        return axios.post(api + 'tiku/status', qs.stringify(params))
    },
    import (params) {
        return axios.post(api + 'tiku/import', qs.stringify(params))
    },
    detail (params) {
        return axios.get(api + 'tiku/detail', { params: params })
    },
}


// 导出接口
export default tiku